document.addEventListener('bmi_selected_item', function (e) {
  const { detail } = e;
  const { selectedItem } = detail;

  if (!selectedItem) return;

  // Get the selected size from Bold Metrics
  const selectedSize = selectedItem.selectedSize;

  // Find the radio input with matching value
  const targetInput = document.querySelector(
    `input[name="option2"][value="${selectedSize}"]`
  );

  if (targetInput) {
    // Get the label associated with this input using the 'for' attribute
    const labelId = targetInput.id;
    const targetLabel = document.querySelector(
      `label[for="${labelId}"]`
    );

    if (targetLabel) {
      targetLabel.click();
    }
  }
});
